import React from 'react';
import {Route, Switch} from 'react-router-dom';
import NotFound from './pages/NotFound';
import routes from './routes';
import './styles/main.scss';

const App = () => (
    <Switch>
        {routes.map(route => {
            let k = route.path;
            if (Array.isArray(route.path)) {
                k = route.path[0];
            }
            k = k.replace(/[^A-Z0-9]/ig, "");
            return (
                <Route key={k} {...route} />
            );
        })}
        <Route path="*" render={({ staticContext }) => {
          if (staticContext) { staticContext.status = 404; }
          return <NotFound status={404} />
        }} />
    </Switch>
);

export default App;
